module.exports = __webpack_public_path__ + "img/document-new-2.9d00d24.png";